import { atom } from "recoil";

export const userRankingAtom = atom<any>({
  key: "userRankingAtom",
  default: "null",
});
